import { Component, OnInit, Input } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';

@Component({
  selector: 'usb-item-disney',
  templateUrl: './item-disney.component.html',
  styleUrls: ['./item-disney.component.scss']
})
export class ItemDisneyComponent implements OnInit {

  @Input() item: any;
  constructor() { }

  ngOnInit() {
  }

}
